import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Category } from '../models/category-model';


@Component({
  selector: 'app-category-sidebar',
  templateUrl: './category-sidebar.component.html',
  styleUrls: ['./category-sidebar.component.css']
})
export class CategorySidebarComponent {
  @Input() categories: Category[] = [];
  @Output() categorySelected = new EventEmitter<number>();

  toggleExpand(category: Category) {
    category.expanded = !category.expanded;
  }

  onSelectCategory(category: Category) {
    this.categorySelected.emit(category.id);
  }
}
